/**
 * @license Copyright (c) 2014-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline.js';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices.js';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor.js';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor.js';
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import Link from '@ckeditor/ckeditor5-link/src/link.js';
import List from '@ckeditor/ckeditor5-list/src/list.js';
import Mention from '@ckeditor/ckeditor5-mention/src/mention.js';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice.js';

class Editor extends ClassicEditor {}

function MentionCustomization(editor) {
  editor.conversion.for('upcast').elementToAttribute({
    view: {
      name: 'span',
      key: 'data-mention',
      classes: 'mention',
      attributes: {
        'data-user-id': true,
      },
    },
    model: {
      key: 'mention',
      value: (viewItem) => {
        const mentionAttribute = editor.plugins.get('Mention').toMentionAttribute(viewItem, {
          userId: viewItem.getAttribute('data-user-id'),
        });

        return mentionAttribute;
      },
    },
    converterPriority: 'high',
  });

  editor.conversion.for('downcast').attributeToElement({
    model: 'mention',
    view: (modelAttributeValue, { writer }) => {
      if (!modelAttributeValue) {
        return;
      }

      return writer.createAttributeElement(
        'span',
        {
          class: 'mention',
          'data-mention': modelAttributeValue.name,
          'data-user-id': modelAttributeValue.userId,
        },
        {
          priority: 20,
          id: modelAttributeValue.uid,
        },
      );
    },
    converterPriority: 'high',
  });
}

// Plugins to include in the build.
Editor.builtinPlugins = [
  Alignment,
  Autoformat,
  Bold,
  CloudServices,
  Essentials,
  FontBackgroundColor,
  FontColor,
  Heading,
  Italic,
  Link,
  List,
  Paragraph,
  PasteFromOffice,
  Underline,
  Mention,
  MentionCustomization,
];

// Editor configuration.
Editor.defaultConfig = {
  toolbar: {
    items: [ 'bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList', '|', 'link'],
  },
  language: 'en',
};

export default Editor;
